/**
 * @generated SignedSource<<9c6a57c31ee23afbb4d71a49616636f6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserOrganizationsDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type UserOrganizationsDeleteMutation$data = {
  readonly removeOrganizationMember: string;
};
export type UserOrganizationsDeleteMutation = {
  response: UserOrganizationsDeleteMutation$data;
  variables: UserOrganizationsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "removeOrganizationMember",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserOrganizationsDeleteMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserOrganizationsDeleteMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeOrganizationMember",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "51e07fc765197623e1dbf57d5ad9012e",
    "id": null,
    "metadata": {},
    "name": "UserOrganizationsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation UserOrganizationsDeleteMutation(\n  $id: ID!\n) {\n  removeOrganizationMember(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "a2b522a930abeb048fedef7de3b94637";

export default node;
